import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class VonalkodTesztlapEditDto extends IdentifiableDto {
	constructor() {
		super();
		this.vonalkodVizsga = null;
		this.vonalkodVizsgazo = null;
		this.elokeszitettPath = null;
	}

	setup(props) {
		super.setup(props);
		this.vonalkodVizsga = props.vonalkodVizsga;
		this.vonalkodVizsgazo = props.vonalkodVizsgazo;
		this.elokeszitettPath = props.elokeszitettPath;
		return this;
	}
}

export default VonalkodTesztlapEditDto;
